module.exports = __webpack_public_path__ + "static/media/youtube.655b1746.svg";